import { withoutTZ } from '../../utils/string-utils';
import {
    CmcClassificationsSyncDoneAction,
    CmcProductsSyncDoneAction,
    CurrentCmcVersionAction, CurrentParameterVersionAction, CurrentStandardVersionAction,
    NotifyUserForCmcVersionChange, NotifyUserForStandardVersionChange,
    RemoveCollectionsFromCmcSyncStatus,
    StandaloneActions,
    StandaloneActionTypes,
    UpdateCollectionSyncStatusAction,
    QuoteCollectionCheckpointAction
} from './standalone.actions';

export class CollectionSyncStatus {
    status : 'IN_PROGRESS' | 'DONE';
    lastSyncDate : Date;
}

const SIX_MONTHS_MS = 3 * 30 * 24 * 60 * 60 * 1000;


export class StandaloneState {
    isFirstTimeSyncDone?: boolean;
    liveCollectionsSyncStatus: { [key: string]: CollectionSyncStatus };
    notifyCmcVersionChange?: boolean;
    notifyStandardVersionChange?: boolean;
    currentCmcVersion?: string;
    currentStandardVersion?: string;
    currentParameterVersion?: string;
    newCmcVersion?: string;
    cmcCollectionsSyncStatus: any;
    quoteCollectionCheckPoint: string;
}
export const standaloneInitialState: StandaloneState = {
    isFirstTimeSyncDone: false,
    liveCollectionsSyncStatus: {},
    notifyCmcVersionChange: false,
    currentCmcVersion : null,
    currentStandardVersion: null,
    currentParameterVersion: null,
    newCmcVersion : null,
    cmcCollectionsSyncStatus: {},
    quoteCollectionCheckPoint: withoutTZ(new Date(Date.now() - SIX_MONTHS_MS).toISOString())+"000"
};

export function standaloneReducer(state: StandaloneState = standaloneInitialState, action: StandaloneActions): StandaloneState {
    switch (action.type) {
        case StandaloneActionTypes.RESET_STANDALONE_STORE:
            return standaloneInitialState;
        case StandaloneActionTypes.FIRST_TIME_SYNC_DONE:
            return {
                ...state,
                isFirstTimeSyncDone: true
            };
        case StandaloneActionTypes.UPDATE_COLLECTION_SYNC_STATUS_ACTION:
            return {
                ...state,
                liveCollectionsSyncStatus: {
                    ...state.liveCollectionsSyncStatus,
                    [(action as UpdateCollectionSyncStatusAction).collectionName]: {
                        status: (action as UpdateCollectionSyncStatusAction).status,
                        lastSyncDate: (action as UpdateCollectionSyncStatusAction).lastSyncDate
                    },
                },
            };

        case StandaloneActionTypes.NOTIFY_USER_FOR_CMC_VERSION_CHANGE:
            return {
                ...state,
                notifyCmcVersionChange: (action as NotifyUserForCmcVersionChange).notify
            };
        case StandaloneActionTypes.NOTIFY_USER_FOR_STANDARD_VERSION_CHANGE:
            return {
                ...state,
                notifyStandardVersionChange: (action as NotifyUserForStandardVersionChange).notify
            };

        case StandaloneActionTypes.REMOVE_COLLECTION_FROM_CMC_SYNC_STATUS:
            const keys = (action as RemoveCollectionsFromCmcSyncStatus).keys;
            const updatedCmcCollectionsSyncStatus = Object.fromEntries(
                Object.entries(state.cmcCollectionsSyncStatus || {})
                    .filter(([key]) => !keys.includes(key))
            );
            return {
                ...state,
                cmcCollectionsSyncStatus: updatedCmcCollectionsSyncStatus
            };
        case StandaloneActionTypes.CMC_PRODUCTS_SYNC_DONE:
            const version1 = (action as CmcProductsSyncDoneAction).version;
            return {
                ...state,
                cmcCollectionsSyncStatus: {
                    ...state.cmcCollectionsSyncStatus,
                    ['fr_cmcproductmanager_products_'+version1]: 'done'
                }
            };
        case StandaloneActionTypes.CMC_CLASSIFICATIONS_SYNC_DONE:
            const version2 = (action as CmcClassificationsSyncDoneAction).version;
            return {
                ...state,
                cmcCollectionsSyncStatus: {
                    ...state.cmcCollectionsSyncStatus,
                    ['fr_cmcproductmanager_classifications_'+version2]: 'done'
                }
            };

        case StandaloneActionTypes.SET_CURRENT_CMC_VERSION:
            const currentCmcVersion = (action as CurrentCmcVersionAction).version;
            return Object.assign({}, state, {currentCmcVersion: currentCmcVersion});

        case StandaloneActionTypes.SET_CURRENT_STANDARD_VERSION:
            const currentStandardVersion = (action as CurrentStandardVersionAction).version;
            return Object.assign({}, state, {currentStandardVersion: currentStandardVersion});

        case StandaloneActionTypes.SET_CURRENT_PARAMETER_VERSION:
            const currentParameterVersion = (action as CurrentParameterVersionAction).version;
            return Object.assign({}, state, {currentParameterVersion: currentParameterVersion});

        case StandaloneActionTypes.SET_QUOTE_COLLECTION_CHECKPOINT:
            const quoteUpdatedAfter = (action as QuoteCollectionCheckpointAction).quoteCollectionCheckPoint;
            return Object.assign({}, state, {quoteCollectionCheckPoint: quoteUpdatedAfter});
    }
    return state;
}
